export const ONBOARDING_KEYS = {
  REDUCER: 'onboarding',
  IS_FIRST_TIME: 'isFirstTime',
  IS_FINISHED: 'isFinished',
  IS_CANCELLED: 'isCancelled',
  CURRENT_STEP: 'currentStep',
  STEPS_BY_KEY: 'stepsByKey',
}
